// Widget-Hülle (Handoff Tickets): Glaskarte r26, Padding 16, Kopf mit Fill-Icon + Titel in Widgetfarbe,
// optional Wasserzeichen-Icon rechts unten und farbiger Schein (Status-Widget).
// Kopf-Variante „kachel“: Icon-Box 28 (--acc-soft) + Titel 15/800 (Einsatz, Verknüpfungen).
import type { CSSProperties, ReactNode } from 'react';
import type { Icon } from '@phosphor-icons/react';

export interface WidgetHuelleProps {
  titel: string;
  icon: Icon;
  /** Titelfarbe (Standard --acc) */
  farbe?: string;
  kopf?: 'klein' | 'kachel';
  /** rechts im Kopf (Zähler, „+ Termin“ …) */
  rechts?: ReactNode;
  /** Wasserzeichen-Icon rechts unten */
  wasserzeichen?: Icon;
  /** farbiger Schein oben rechts (color-mix 18 %) */
  schein?: string;
  /** aria-Bezeichnung des Abschnitts (Standard: Titel) */
  ariaLabel?: string;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}

export function WidgetHuelle({ titel, icon: I, farbe = 'var(--acc)', kopf = 'klein', rechts, wasserzeichen: W, schein, ariaLabel, className = '', style, children }: WidgetHuelleProps) {
  return (
    <section aria-label={ariaLabel ?? titel} className={`immo-glas relative flex min-w-0 flex-col ${className}`}
      style={{
        borderRadius: 26, padding: 16, gap: 12, overflow: 'hidden',
        ...(schein ? { backgroundImage: `radial-gradient(120% 100% at 100% 0%, color-mix(in srgb, ${schein} 18%, transparent), transparent 65%), var(--glass)` } : {}),
        ...style,
      }}>
      {W && <W aria-hidden size={84} weight="fill" className="pointer-events-none absolute" style={{ right: -10, bottom: -16, opacity: 0.1, color: farbe }} />}
      <div className="relative flex min-w-0 items-center justify-between" style={{ gap: 8 }}>
        {kopf === 'kachel' ? (
          <h2 className="m-0 flex min-w-0 items-center" style={{ gap: 9, fontSize: 15, fontWeight: 800, color: 'var(--ink)' }}>
            <span aria-hidden className="inline-flex shrink-0 items-center justify-center" style={{ width: 28, height: 28, borderRadius: 9, background: 'var(--acc-soft)', color: 'var(--acc)' }}>
              <I size={16} weight="fill" />
            </span>
            <span className="truncate">{titel}</span>
          </h2>
        ) : (
          <h2 className="m-0 flex min-w-0 items-center" style={{ gap: 7, fontSize: 13, fontWeight: 700, color: farbe }}>
            <I aria-hidden size={16} weight="fill" className="shrink-0" />
            <span className="truncate">{titel}</span>
          </h2>
        )}
        {rechts !== undefined && <div className="flex shrink-0 items-center" style={{ gap: 6, fontSize: 12, color: 'var(--ink3)' }}>{rechts}</div>}
      </div>
      <div className="relative flex min-w-0 flex-col" style={{ gap: 12 }}>{children}</div>
    </section>
  );
}
